import React, { useState } from "react";
import { AppBar, Box, makeStyles, Tab, Tabs } from "@material-ui/core";
import TabPublicadas from "./tabPublicadas";
import TabEnRevision from "./tabEnRevision";
import TabProgramadas from "./tabProgramadas";
// import TabTemasInteres from "./tabTemasInteres";

function Page(props) {
  const [value, setValue] = useState(0);

  const classes = useStyles();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static">
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Noticias Publicadas" />
          <Tab label="Noticias En Revisión" />
          <Tab label="Noticias Programadas" />
          {/* <Tab label="Temas de Interés" /> */}
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0}>
        {value === 0 ? <TabPublicadas /> : null}
      </TabPanel>
      <TabPanel value={value} index={1}>
        {value === 1 ? <TabEnRevision /> : null}
      </TabPanel>
      <TabPanel value={value} index={2}>
        {value === 2 ? <TabProgramadas /> : null}
      </TabPanel>
      {/* <TabPanel value={value} index={3}>
        {value === 3 ? <TabTemasInteres /> : null}
      </TabPanel> */}
    </div>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      {...other}
    >
      {value === index && (
        <Box p={1}>
          {children}
        </Box>
      )}
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default Page;